
import Client from "../../Client";
import Exceptions from "../../Exceptions";
import { getProvinceList } from "../../services/api/meta";
import { AlertDrawerController } from "../../views/sections/sidebar/AlertDrawer";
import { Notifier } from "../conductor";

export class ProvinceListController {
    constructor(options) {

        /** @type {{ lgu: string, id: string }} */
        this.reference = options.ref;
        this.itemRedirect = options.itemRedirect;

        const self = this;        
        this.notifiers = {
            ready: new Notifier(false),
            unauthorized: new Notifier(false),
            reloading: new Notifier(false),
            reloaded: new Notifier(),
            alert: new AlertDrawerController()
        };

        this.status = {
            get ready() { return self.notifiers.ready.get() },
            get reloading() { return self.notifiers.reloading.get() },
            get unauthorized() { return self.notifiers.unauthorized.get() }
        };

        this.initialize();
    }

    async initialize() {
        Client.ensureSignedIn();
        if(this.isInitialized) return; this.isInitialized = true;

        try {
            await this.loadData();
        } catch(e) {
            if(e.unauthorized) return this.notifiers.unauthorized.update(true);
        }
        
        this.notifiers.ready.update(true);
    }

    async loadData() {
        this.data = await getProvinceList();
    }

    async refresh() {
        const { reloading, reloaded, alert } = this.notifiers;
        reloading.update(true);
        alert.close();

        try {
            await this.loadData();
            reloaded.notify();
        } catch(e) {
            const semantics = Exceptions.getARESemantics(e);
            alert.alert(semantics.message, { status: "error", title: semantics.title, retry: () => this.refresh() });
        }

        reloading.update(false);
    }
    
    async changeDate(month, year) {
        this.reference.month = month;
        this.reference.year = year;
        await this.refresh();
    }

    async redirectItem(provinceId) {
        const { month, year } = this.reference;
        this.itemRedirect({ province: provinceId, month, year });
    }
}